import React, { useState, useRef, useEffect } from "react";

export default function SearchableSelect({options,value,onChange,placeholder,disabled,lang}){
  const effLang=lang||(typeof document!=="undefined"?(document.documentElement.lang||"en"):"en");
  const isRTL=effLang==="ar";
  const defaultPh=isRTL?"— اختر —":"— select —";
  const searchPh=isRTL?"بحث...":"Search...";
  const noMatchesLabel=isRTL?"لا تطابقات":"No matches";
  const [open,setOpen]=useState(false);
  const [search,setSearch]=useState("");
  const ref=useRef(null);
  const selected=options.find(o=>o.value===value);
  const filtered=search?options.filter(o=>o.label.toLowerCase().includes(search.toLowerCase())):options;
  useEffect(()=>{
    const handler=e=>{if(ref.current&&!ref.current.contains(e.target))setOpen(false);};
    document.addEventListener("mousedown",handler);return()=>document.removeEventListener("mousedown",handler);
  },[]);
  return(
    <div ref={ref} style={{position:"relative"}}>
      <div className="fi" style={{cursor:disabled?"not-allowed":"pointer",display:"flex",alignItems:"center",justifyContent:"space-between",minHeight:36,opacity:disabled?.6:1,background:disabled?"var(--g50)":"",userSelect:"none"}} onClick={()=>{if(!disabled)setOpen(p=>!p);}}>
        <span style={{flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",color:selected?"var(--ink)":"var(--g400)"}}>{selected?selected.label:(placeholder||defaultPh)}</span>
        <span style={{fontSize:10,color:"var(--g400)",marginInlineStart:4}}>▾</span>
      </div>
      {open&&!disabled&&<div style={{position:"absolute",top:"100%",left:0,right:0,zIndex:1200,background:"#fff",border:"1px solid var(--g200)",borderRadius:8,boxShadow:"0 8px 24px rgba(0,0,0,.12)",maxHeight:220,display:"flex",flexDirection:"column"}}>
        <div style={{padding:6,borderBottom:"1px solid var(--g100)"}}>
          <input className="fi" value={search} onChange={e=>setSearch(e.target.value)} placeholder={searchPh} autoFocus style={{fontSize:13,margin:0}}/>
        </div>
        <div style={{overflowY:"auto",flex:1}}>
          {placeholder&&<div style={{padding:"7px 12px",fontSize:13,color:"var(--g400)",cursor:"pointer",background:!value?"var(--g50)":""}} onClick={()=>{onChange("");setOpen(false);setSearch("");}}>{placeholder}</div>}
          {filtered.map(o=><div key={o.value} style={{padding:"7px 12px",fontSize:13,cursor:"pointer",background:o.value===value?"var(--b50)":"",fontWeight:o.value===value?600:400}} onMouseDown={e=>e.preventDefault()} onClick={()=>{onChange(o.value);setOpen(false);setSearch("");}}>{o.label}</div>)}
          {!filtered.length&&<div style={{padding:"10px 12px",fontSize:12,color:"var(--g400)"}}>{noMatchesLabel}</div>}
        </div>
      </div>}
    </div>
  );
}
